import React from 'react';
import loader2 from '../../assets/Animation - 1745520690413.gif'; // Your GIF

const Loader = () => {
  return (
    <div style={styles.loaderWrapper}>
      <div style={styles.loaderContent}>
        <img
          src={loader2}
          alt="Loading animation"
          style={styles.loaderImage}
        />
        <h1 style={styles.loaderText}>Loading...</h1>
      </div>
    </div>
  );
};

const styles = {
  loaderWrapper: {
    width: "100%",
    height: "100vh",
    background: "#333d79",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    zIndex: 9999,
    position: "fixed",
    top: 0,
    left: 0,
  },
  loaderContent: {
    textAlign: "center",
  },
  loaderImage: {
    width: "150px",
    height: "150px",
    // marginBottom: "10px",
  },
  loaderText: {
    margin: 0,
    color: "white",
    fontSize: "20px",
    fontWeight: "600",
    letterSpacing: "1px",
  },
};

export default Loader;
